import { featuresSubmenu } from "../../MenuBar/viewSubmenu";
import genericAnnotationProperties from "./GenericAnnotationProperties";
export default genericAnnotationProperties({
  visSubmenu: featuresSubmenu,
  annotationType: "feature"
});
